import React from 'react'
import { Link } from 'react-router-dom'

export default function Header({ title, to, HeaderIcon }) {
    return (

        <div className='row-header-wrap'>
            {HeaderIcon && (

                <HeaderIcon size={20} />
            )}
            <h2>{title}</h2>
            {to && (

                <Link to={to} className='more'>更多</Link>
            )}
        </div>
    )
}
